// Delegación de eventos (Este debe cargar de inmediato porque escucha los clics)
  document.addEventListener('click', function(e) {
    const target = e.target.closest('.appointment-booking, .appointment-booking-services, .appointment-booking-eval, .appointment-booking-treat, .appointment-booking-member');
    
    if (!target) return;
    e.preventDefault();

    let path = '/cart/menu';
    if (target.classList.contains('appointment-booking-services')){
      openModalServices();
    }
    else if (target.classList.contains('appointment-booking-eval')) 
    {
      openCalendar('skin-evaluation-150');
      return;
    }
    else if (target.classList.contains('appointment-booking-treat')){
      openCalendar('personalized-treatment-350');
      return;
    }
    else if (target.classList.contains('appointment-booking-member')) path = '/cart/menu/Memberships';


    openModalServices();
  });
